module.exports = "https://pm2019.reeltime.no/public/images/pm_logo_new@2x.ecb901f3.png";